module.exports = __webpack_public_path__ + "static/media/warmup.7044e9e8.jpg";